/**
 * Use Case: Fetch Tiering Settings
 * Business logic for fetching tiering settings data.
 */

import type {
	FetchTieringSettingsParams,
	TieringSettingsItem,
	TieringSettingsPaginatedResult,
} from "../model/TieringSettingsModel";
import type { ITieringSettingsRepository } from "../repository/ITieringSettingsRepository";
import { tieringSettingsContainer, TYPES } from "../../di/TieringSettingsModule";

export type FetchTieringSettingsResult = {
	readonly items: readonly TieringSettingsItem[];
};

/**
 * Fetch all tiering settings (backwards-compatible, non-paginated).
 */
export const FetchTieringSettingsUseCase =
	async (): Promise<FetchTieringSettingsResult> => {
		const repository = tieringSettingsContainer.get<ITieringSettingsRepository>(
			TYPES.ITieringSettingsRepository,
		);
		const items = await repository.fetchAll();

		return { items };
	};

/**
 * Fetch tiering settings with pagination and optional filters.
 */
export const FetchTieringSettingsPaginatedUseCase = async (
	params: FetchTieringSettingsParams = {},
): Promise<TieringSettingsPaginatedResult> => {
	const repository = tieringSettingsContainer.get<ITieringSettingsRepository>(
		TYPES.ITieringSettingsRepository,
	);

	return repository.fetchPaginated(params);
};
